/* Flooring Surgeons – sample button.
   3 free samples (owner, 4 Oct 2026: no longer monthly), 99p each after (migration/accounts/DESIGN.md).
   Each floor's sample is its own variant of the unlisted "Floor sample" product (99p; data-variant-id from
   snippets/fs-sample-variant.liquid). The price is applied by Shopify (automatic "free samples" discount), so this
   only adds the sample variant and explains what it will cost. One basket for samples, floors and accessories
   (owner, 4 Oct 2026): max 3 samples per order (owner, 15 Oct 2026 – was 12; data-max-order); more than one of the same
   floor is fine (owner, 13 Oct 2026 – a second click adds one more). Samples never share an order with flooring
   (owner, 15 Oct 2026 – assets/fs-basket-rules.js). Then the basket re-renders (assets/fs-cart.js) and the drawer opens; the
   drawer explains the free allowance, so the button only flashes "Added" (no text under the card – it stretched the row).
   Data attributes (snippets/fs-sample-allowance.liquid): data-variant-id, data-free-left, data-free-total, data-signed-in. */
/* A basket line is a sample if it's the unlisted "Floor sample" product (current model) or an old in-product
   "Free sample" variant (until the migration's remove-old-samples step has run). */
(() => {
if (customElements.get('fs-sample-button')) return; // the script can be included by several sections
const FS_SAMPLE_HANDLE = 'floor-sample';
const isSample = (item) =>
  item.product_type === 'Sample' || item.handle === FS_SAMPLE_HANDLE || /-SAMPLE$/i.test(item.sku || '') || /sample/i.test(item.variant_title || '');
/* "Added" animation (owner, 13 Oct 2026: "animate this a lot nicer"): press-in, a shimmer while the request runs, then a teal
   fill sweeps across, the bag gives way to a tick that draws itself and "Added" springs up; it eases back after ~2s.
   One stylesheet for card and product-page buttons alike; reduced motion = a plain colour change. */
const FS_ANIM_CSS = `
.fs-anim { position: relative; isolation: isolate; transition: transform 0.15s ease; }
.fs-anim__clip { position: absolute; inset: -1px; overflow: hidden; border-radius: inherit; pointer-events: none; }
.fs-anim:active:not(:disabled) { transform: scale(0.97); }
.fs-anim.is-loading:disabled { opacity: 1; cursor: pointer; }
.fs-anim__idle { display: inline-flex; align-items: center; justify-content: center; gap: inherit; min-width: 0;
  transition: transform 0.35s cubic-bezier(0.2, 0.8, 0.2, 1), opacity 0.18s ease; }
.fs-anim__fill, .fs-anim__shine { position: absolute; inset: 0; z-index: -1; border-radius: inherit; pointer-events: none; }
.fs-anim__fill { background: var(--fs-teal-strong, #2f7d6f); transform: scaleX(0); transform-origin: left center;
  transition: transform 0.45s cubic-bezier(0.65, 0, 0.35, 1); }
.fs-anim__shine { z-index: 1; opacity: 0; background: linear-gradient(100deg, transparent 30%, rgb(255 255 255 / 0.35) 50%, transparent 70%);
  transform: translateX(-100%); }
.fs-anim.is-loading .fs-anim__shine { opacity: 1; animation: fs-anim-shine 0.9s linear infinite; }
.fs-anim__done { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; gap: 0.6rem; color: #fff;
  opacity: 0; transform: translateY(70%); pointer-events: none;
  transition: transform 0.45s cubic-bezier(0.34, 1.56, 0.64, 1) 0.1s, opacity 0.2s ease 0.1s; }
.fs-anim__tick { flex: none; width: 2rem; height: 2rem; fill: none; stroke: currentColor; stroke-width: 2.6; stroke-linecap: round;
  stroke-linejoin: round; stroke-dasharray: 1; stroke-dashoffset: 1; transition: stroke-dashoffset 0.35s ease 0.35s; }
.fs-anim.is-added { color: #fff; animation: fs-anim-pop 0.5s ease 0.15s; }
.fs-anim.is-added .fs-anim__fill { transform: scaleX(1); }
.fs-anim.is-added .fs-anim__idle { opacity: 0; transform: translateY(-40%); }
.fs-anim.is-added .fs-anim__done { opacity: 1; transform: none; }
.fs-anim.is-added .fs-anim__tick { stroke-dashoffset: 0; }
@keyframes fs-anim-shine { to { transform: translateX(100%); } }
@keyframes fs-anim-pop { 0% { transform: scale(1); } 40% { transform: scale(1.04); } 100% { transform: scale(1); } }
@media (prefers-reduced-motion: reduce) {
  .fs-anim, .fs-anim * { transition-duration: 0.01ms !important; transition-delay: 0s !important; animation: none !important; }
}`;
const fsAnimStyle = () => {
  if (document.getElementById('FsAnimCss')) return;
  const st = document.createElement('style');
  st.id = 'FsAnimCss';
  st.textContent = FS_ANIM_CSS;
  document.head.append(st);
};
{
  customElements.define(
    'fs-sample-button',
    class FsSampleButton extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.message = this.querySelector('.fs-sample__message');
        this.button.addEventListener('click', () => this.add());
        this.dress();
      }

      /** Wrap the label and add the fill / shine / "Added" layers the animation uses (once). */
      dress() {
        if (this.button.classList.contains('fs-anim')) return;
        fsAnimStyle();
        const idle = document.createElement('span');
        idle.className = 'fs-anim__idle';
        idle.append(...this.button.childNodes);
        this.button.append(idle);
        this.button.insertAdjacentHTML(
          'beforeend',
          '<span class="fs-anim__clip" aria-hidden="true"><span class="fs-anim__fill"></span><span class="fs-anim__shine"></span>' +
            '<span class="fs-anim__done"><svg class="fs-anim__tick" viewBox="0 0 24 24"><path d="M5 12.5l4.2 4.2L19 7" pathLength="1"/></svg>Added</span></span>'
        );
        this.button.classList.add('fs-anim');
      }

      say(text) {
        this.message.classList.remove('visually-hidden');
        this.message.textContent = text;
        this.message.hidden = false;
        // On a product card the message floats over the card (CSS) – hide it again after a moment.
        clearTimeout(this.sayTimer);
        if (this.classList.contains('fs-card__sample')) this.sayTimer = setTimeout(() => { this.message.hidden = true; }, 4000);
      }

      /** "Added" on the button itself (the drawer shows the details); screen readers hear it via the hidden message. */
      flash() {
        clearTimeout(this.sayTimer);
        this.message.textContent = 'Sample added';
        this.message.classList.add('visually-hidden');
        this.message.hidden = false;
        clearTimeout(this.flashTimer);
        this.button.classList.add('is-added');
        this.flashTimer = setTimeout(() => this.button.classList.remove('is-added'), 2200);
      }

      /** Message after adding: `inBasket` = sample units now in the basket (including this one). */
      explain(inBasket) {
        const total = parseInt(this.dataset.freeTotal, 10) || 3;
        const left = Math.max(0, parseInt(this.dataset.freeLeft ?? total, 10));
        const plural = (n, w) => `${n} ${w}${n === 1 ? '' : 's'}`;
        if (this.dataset.signedIn === 'true') {
          const after = left - inBasket;
          if (after > 0) return `Sample added – free. ${plural(after, 'free sample')} left.`;
          if (after === 0) return `Sample added – free. Extra samples 99p.`;
          return 'Sample added – 99p.';
        }
        if (inBasket <= total) {
          return `Sample added – ${total} free samples when you sign in.`;
        }
        return 'Sample added – extra samples 99p.';
      }

      async sampleUnitsInCart(root) {
        const cart = await fetch(`${root}cart.js`).then((r) => r.json());
        return cart.items.filter(isSample);
      }

      async add() {
        const root = window.Shopify?.routes?.root || '/';
        const id = parseInt(this.dataset.variantId, 10);
        const maxOrder = parseInt(this.dataset.maxOrder, 10) || 3;
        this.button.disabled = true;
        this.button.classList.add('is-loading');
        try {
          // Samples and flooring never share an order (assets/fs-basket-rules.js)
          if (window.FSBasketRules && !(await window.FSBasketRules.allow('sample'))) return;
          const samples = await this.sampleUnitsInCart(root);
          const units = samples.reduce((n, i) => n + (Number(i.quantity) || 0), 0);
          if (units >= maxOrder) {
            this.say(`Your sample box is full – ${maxOrder} samples per order.`);
            return;
          }
          const res = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
          });
          if (!res.ok) throw new Error('add failed');
          // Re-render the basket (drawer + cart page, assets/fs-cart.js), then show it – except on the cart page itself.
          if (window.FsCartRefresh) await window.FsCartRefresh();
          else document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'fs-sample' });
          }
          this.message.hidden = true;
          const drawer = !document.querySelector('fs-cart[data-context="page"]') && document.querySelector('cart-drawer');
          if (drawer) {
            drawer.open();
            this.flash();
          } else this.say(this.explain(units + 1)); // basket page: no drawer to explain it
        } catch (e) {
          this.say('Sorry, we couldn’t add the sample. Please try again.');
        } finally {
          this.button.disabled = false;
          this.button.classList.remove('is-loading');
        }
      }
    }
  );
}
})();
